export enum FormMessagePattern {
    ALL = 'all',
    SINGLE = 'single'
}